import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav7").addClass("active");
var swiper = new Swiper(".mySwiper", {
    pagination: {
      el: ".progressbar .swiper-pagination",
      type: "progressbar",
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 0,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: '3%',
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 4,
            spaceBetween: '3.71%',
        }
    },
});
let h_max = 0; //定义一个默认变量，并赋值为0，用于比较	
$('.swiper .swiper-slide p').each(function() { //遍历相同样式名的元素
    let h = $(this).height(); //获取每个元素的高度，（可根据需要使用outerHeight、innerHeight）
    h_max = h > h_max ? h : h_max; //比较获取的元素高度值和默认变量，如果比0大，则取获取的值，否则取0
});
$('.swiper .swiper-slide p').height(h_max); //给每一个元素设置相同的高度	
